import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["how-much-to-drink"]!;

export function Body() {
  return (
    <>
      <p>
        "Drink before you get thirsty" has been common advice for runners. Research shows that
        drinking too much in a marathon can be more dangerous than drinking too little.
      </p>

      <h2>What the researchers did</h2>
      <p>
        At the 2002 Boston Marathon, researchers weighed runners before and after the race, took
        a blood sample at the finish and asked how much they had drunk. 488 runners provided a
        usable blood sample.
      </p>
      <p>
        In a smaller study from 2019, nine trained endurance athletes did three one-hour cycling
        time trials in 30 °C: without drinking, drinking when thirsty, and drinking enough to
        replace almost all the sweat they lost.
      </p>

      <h2>What they found</h2>
      <p>
        In Boston, 13 percent of the runners had too little sodium in the blood, a condition
        called hyponatremia, and 0.6 percent had a critically low level. It was linked to gaining
        weight during the race, which happens when you drink more than you lose. Runners who
        took more than four hours were at much higher risk than those under 3:30. Drinking more
        than three litres and drinking at every mile were also linked to it. Sports drink instead
        of water did not protect against it.
      </p>
      <p>
        In the cycling study, the three ways of drinking gave the same performance over an hour.
      </p>

      <h2>What it means for you</h2>
      <p>
        Drink when you are thirsty. You don't need to drink at every station, and slower runners
        who are out for a long time should be especially careful not to drink too much.
      </p>
      <p>
        A simple check is to weigh yourself before and after a long run. If you are heavier
        afterwards, you drank more than you needed. Headache, nausea, swelling or confusion
        during or after a long race can be signs of hyponatremia. Get medical help, and don't
        keep drinking.
      </p>

      <h2>What the studies can't tell you</h2>
      <p>
        The marathon study shows a link, not that each litre caused the problem. The cycling
        study was small and lasted an hour, which is much shorter than a marathon. In hot
        conditions and long races, you may need to drink more than in cool weather.
      </p>

      <h2>How we use it</h2>
      <p>
        Your long runs in PX7 Training are a good time to find out how much you actually drink
        and need, so you have a plan for race day.
      </p>

      <h2>Sources</h2>
      <ul>
        <li>
          Almond et al. (2005), Hyponatremia among runners in the Boston Marathon.{" "}
          <a href="https://doi.org/10.1056/NEJMoa043901">New England Journal of Medicine</a>.
        </li>
        <li>
          Perreault-Briere et al. (2019), Effect of thirst-driven fluid intake on 1 h cycling
          time-trial performance in trained endurance athletes.{" "}
          <a href="https://doi.org/10.3390/sports7100223">Sports</a>.
        </li>
      </ul>
    </>
  );
}
